import { OpenModal,PcsModalActions, PcsModalActionTypes } from '@app/core/pcs-modal/modal.actions';
import { ModalPayload } from '@app/core/pcs-modal/model/modal-payload';
import { createHandler, createReducer } from '@app/util';
import * as R from 'ramda';

export interface State {
  modals: ModalPayload[];
}

const initialState: State = {
  modals: []
};

const openModal = (state: State, {payload: modal}: OpenModal): State =>
  R.evolve({
    modals: R.append(modal)
  },
  state
  );

const closeModal = (state: State): State =>
  R.evolve({
    modals: R.remove(state.modals.length - 1, 1)
  },
  state
  );

const reducer = createReducer<State, PcsModalActions>([
  createHandler(PcsModalActionTypes.OpenModal, openModal),
  createHandler(PcsModalActionTypes.CloseModal, closeModal),
  createHandler(PcsModalActionTypes.CloseModalWithReason, closeModal)
],
initialState
);

export function modalReducer(
  state: State = initialState,
  action: PcsModalActions
): State {
  return reducer(state, action);
}

export const getModals = (state: State) => state.modals;
